import Backbone from 'backbone';

export default {
    publish() {
        Backbone.trigger.apply(Backbone, arguments);
    },
    subscribe() {
        Backbone.on.apply(Backbone, arguments);
    },
    unsubscribe() {
        Backbone.off.apply(Backbone, arguments);
    }
};
